<template>
<!-- 考试管理 -->
    <div class="componentContainer">
        <el-card class="fatherCard">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item class="currentLocation"><i class="el-icon-location-outline"></i> 当前位置</el-breadcrumb-item>
                    <el-breadcrumb-item>考试管理</el-breadcrumb-item>                
                    <el-breadcrumb-item>考试管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div>
                <el-tabs v-model="activeName"  class="elTab" @tab-click="backToManagerExam()">
                    <el-tab-pane label="考试管理" name="first"  >
                        <div v-show="!modifyFlag" class="list_container">                  
                            <div class="search-container" >
                                <div>
                                    <el-input v-model="examQueryParams.examName"  @keyup.enter.native="queryExamList()" clearable placeholder="考试关键词" class="impoWorldInput"></el-input>
                                    <el-select v-model="examQueryParams.state"  @change="queryExamList()" placeholder="考试状态">
                                        <el-option label="报名中"  value="0" ></el-option>   
                                        <el-option label="考试中"  value="1"></el-option>
                                        <el-option label="已结束"  value="2"></el-option>             
                                    </el-select>
                                    <!-- <el-date-picker v-model="signDateRange"  class="dateRange" type="datetimerange" range-separator="至 " start-placeholder="报名开始日期" end-placeholder="报名结束日期"></el-date-picker> -->
                                    <el-date-picker v-model="examDateRange"  class="dateRange" type="datetimerange" range-separator="至 " start-placeholder="考试开始日期" end-placeholder="考试结束日期"></el-date-picker>
                                    <el-button type="primary" @click="queryExamList()" class="searchButton">查询</el-button>
                                </div>
                                <el-button type="danger" @click="deleteSelectedExames()" class="searchButton">批量删除</el-button>
                            </div> 
                            <el-table :data="examList" class="examListTable"  stripe highlight-current-row max-height="600px"
                                        :header-cell-style="{background:'#eef1f6',color:'#606266'}"  ref="multipleTable" @selection-change="handleSelectionChange"
                                        :row-style="{height:'55px'}" :cell-style="{padding:0}">
                                <el-table-column type="expand" width="50">
                                    <template slot-scope="props">
                                        <el-form label-position="left" inline class="demo-table-expand">
                                            <el-form-item label="报名开始时间" class="halfItem">
                                                <span>{{ props.row.signStartTime }}</span>
                                            </el-form-item>
                                            <el-form-item label="考试开始时间" class="halfItem">
                                                <span>{{ props.row.examStartTime }}</span>
                                            </el-form-item>
                                            <el-form-item label="结果公告时间" class="halfItem">
                                                <span>{{ props.row.resultReleaseTime }}</span>
                                            </el-form-item>
                                            <el-form-item label="报名结束时间" class="halfItem">
                                                <span>{{ props.row.signEndTime }}</span>
                                            </el-form-item>
                                            <el-form-item label="考试结束时间" class="halfItem">
                                                <span>{{ props.row.examEndTime }}</span>
                                            </el-form-item>
                                            <el-form-item label="最后更新时间" class="halfItem">
                                                <span>{{ props.row.updateTime }}</span>
                                            </el-form-item>
                                        </el-form>
                                    </template>
                                </el-table-column>    
                                <el-table-column  type="selection" width="55"></el-table-column> 
                                <el-table-column label="序号" align="center" type="index" width="50" ></el-table-column> 
                                <el-table-column prop="examId" label="考试ID" align="center" v-if="false"></el-table-column>
                                <el-table-column prop="examName" label="考试名称"   align="center" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="examMsg" label="考试信息" width="300"  align="center" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="state" label="考试状态" width="100" align="center">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.state === '0'">{{'报名中'}}</span>
                                        <span v-else-if="scope.row.state === '1'">{{'考试中'}}</span>
                                        <span v-else-if="scope.row.state === '2'">{{'已结束'}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="signStuNumber" label="报名人数" width="100" align="center"></el-table-column>
                                <el-table-column prop="examDuration" label="考试时长" width="100" align="center"></el-table-column>  
                                <el-table-column prop="createBy" label="创建者" v-if="false"></el-table-column>
                                <el-table-column prop="createName" label="创建者" width="150" align="center"></el-table-column>
                                <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
                                <el-table-column  label="操作" width="250"  align="center">
                                    <template slot-scope="scope">
                                        <el-button @click="modifyExamInfo(scope.row)" type="warning" size="mini" v-if="scope.row.state == '0'">编辑</el-button>
                                        <el-button @click="queryExamRecord(scope.row)" type="info" size="mini" v-else>考试记录</el-button>
                                        <!-- <el-button @click="deleteById(scope.row.id)" type="danger" size="small">删除</el-button> -->
                                    </template>
                            </el-table-column>
                            </el-table>         
                            <el-pagination @size-change="examSizeChange" @current-change="examCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                                :current-page="examQueryParams.pageNum" :page-sizes="[10, 20, 50]" :page-size="examQueryParams.pageSize" :total="examTotalCount" class="page">   
                            </el-pagination>   
                        </div>
                        <div class="modfiyExamContainer" v-show="modifyFlag"> 
                            <div style="height:690px">
                                <el-scrollbar style="height:100%">
                                    <el-form  :model="modfiyExamForm" :rules="rules" ref="modfiyExamForm" class="demo-ruleForm" >
                                        <div class="createExamContainer">
                                            <div class="titleDiv">
                                                <span class="createHeaderTitle"><i class="el-icon-user"></i> 修改考试-考试对象</span><span class="singAnswerTip">设置参加考试的考生组(非必填，考生自行报名参加)</span>
                                            </div>
                                            <div >
                                                <table  style="width: 940px"  class="createExamTable">
                                                    <tbody>
                                                        <tr >
                                                            <th>考试对象</th>
                                                            <td style="display:flex"> 
                                                                <el-button @click="addExamineeGroup()" type="primary" size="small">添加考生组</el-button>
                                                                <el-button @click="manageGroup()" type="warning" size="small">管理考生组</el-button>
                                                            </td>
                                                            <th>原有考生</th>
                                                            <td class="existGroupTd"> 
                                                                <el-scrollbar style="height:100%">
                                                                    <el-tag v-for="tag in existExaminees" :key="tag.userId"  type="success"
                                                                        :disable-transitions="false" >
                                                                        {{tag.relayName}}
                                                                    </el-tag>
                                                                </el-scrollbar>
                                                            </td>    
                                                        </tr>
                                                        <tr>
                                                            
                                                        </tr>
                                                        <tr >
                                                            <th >已选考生组</th>
                                                            <td class="groupTd"> 
                                                                <el-scrollbar style="height:100%">
                                                                    <el-tag v-for="tag in selectedGroupTags" :key="tag.groupId" closable type="success"
                                                                        :disable-transitions="false" @close="handleCloseTag(tag)">
                                                                        {{tag.groupName}}
                                                                    </el-tag>
                                                                </el-scrollbar>
                                                            </td>      
                                                        </tr>
                                                </tbody>
                                                </table>
                                            </div> 
                                        </div>
                                        <div class="createExamContainer">
                                            <div class="titleDiv">
                                                <span class="createHeaderTitle"><i class="el-icon-s-home"></i> 修改考试-基本信息 </span><span class="singAnswerTip">填写考试基本信息</span>
                                            </div>
                                            <div >
                                                <table  style="width: 940px"  class="createExamTable">
                                                    <tbody>
                                                        <tr>
                                                            <td > 
                                                                <el-form-item label="考试名称"  prop="examName">  
                                                                    <el-input v-model.trim="modfiyExamForm.examName" placeholder="请输入考试名称"      readonly></el-input>
                                                                </el-form-item>
                                                            </td>
                                                            <el-form-item label="设置试卷"  prop="examPaperName">
                                                                <el-input  placeholder="请选择试卷" @focus="openSelectPaperDialog()" v-model="modfiyExamForm.examPaperName"  >
                                                                    <el-button slot="append"   @click="openSelectPaperDialog()"  icon="el-icon-search" 
                                                                    style="height:40px;background-color:#409EFF;color:white;border-top-left-radius:0;border-bottom-left-radius:0"></el-button>
                                                                </el-input>
                                                                <el-input   v-model="modfiyExamForm.paperId"  v-if="false"></el-input>
                                                            </el-form-item>
                                                        </tr>
                                                        <tr>
                                                            <td >
                                                                <el-form-item label="考试须知"  prop="examMsg">
                                                                    <el-input v-model.trim="modfiyExamForm.examMsg" type="textarea" style="width:800px;" :autosize="{ minRows: 3, maxRows: 3}"  ></el-input>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="createExamContainer">
                                            <div class="titleDiv">
                                                <span class="createHeaderTitle"><i class="el-icon-date"></i> 时间设置</span><span class="singAnswerTip">填写考试时间安排</span>
                                            </div>
                                            <div >
                                                <table  style="width: 940px"  class="createExamTable">
                                                    <tbody>
                                                        <tr>
                                                            <td > 
                                                                <el-form-item label="报名开始时间"  prop="signStartTime">
                                                                    <el-date-picker v-model="modfiyExamForm.signStartTime" type="datetime" placeholder="选择报名开始时间"></el-date-picker>                   
                                                                </el-form-item>
                                                            </td>
                                                        <td > 
                                                                <el-form-item label="报名结束时间"  prop="signEndTime">
                                                                    <el-date-picker v-model="modfiyExamForm.signEndTime" type="datetime" placeholder="选择报名结束时间"></el-date-picker>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td > 
                                                                <el-form-item label="考试开始时间"  prop="examStartTime">
                                                                    <el-date-picker v-model="modfiyExamForm.examStartTime" type="datetime" placeholder="选择考试开始时间"></el-date-picker>
                                                                </el-form-item>
                                                            </td>
                                                            <!-- <th>考试结束时间</th> -->
                                                            <td > 
                                                                <el-form-item label="考试结束时间"  prop="examEndTime">
                                                                    <el-date-picker v-model="modfiyExamForm.examEndTime" type="datetime" placeholder="选择考试结束时间"></el-date-picker>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                    <!-- <th>成绩公布时间</th> -->
                                                            <td > 
                                                                <el-form-item label="成绩公布时间"  prop="resultReleaseTime">
                                                                    <el-date-picker v-model="modfiyExamForm.resultReleaseTime" type="datetime" placeholder="选择考试开始时间"></el-date-picker>                               
                                                                </el-form-item>
                                                            </td>
                                                            <td > 
                                                                <el-form-item label="考试时长/分钟"  prop="examDuration">
                                                                    <el-input-number v-model="modfiyExamForm.examDuration" controls-position="right" style="width:306px" :min="1" :max="10000"></el-input-number>
                                                                </el-form-item>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <el-button  type="success" style="margin-left:50px;width:300px;" @click="submitExamInfo('modfiyExamForm')" :loading="submitLoading">{{submitLoading ? '提交中 ...' : '提 交'}}</el-button>
                                                    <el-button @click="modifyFlag = false" type="info">返 回</el-button>  
                                                </table>
                                            </div>
                                        </div>
                                    </el-form>
                                </el-scrollbar>

                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="创建考试" name="second" >
                        <div style="height:690px">
                            <el-scrollbar style="height:100%">
                                <el-form :model="createExamForm" :rules="rules"  ref="createExamForm" class="demo-ruleForm">
                                    <div class="createExamContainer">
                                        <div class="titleDiv">
                                            <span class="createHeaderTitle"><i class="el-icon-user"></i> 考试对象</span><span class="singAnswerTip">设置参加考试的考生组(非必填，考生自行报名参加)</span>
                                        </div>
                                        <div >
                                            <table  style="width:940px"  class="createExamTable">
                                                <tbody>
                                                    <tr>
                                                        <th>考试对象</th>
                                                        <td > 
                                                            <el-button @click="addExamineeGroup()" type="primary" size="small">添加考生组</el-button>
                                                            <el-button @click="manageGroup()" type="warning" size="small">管理考生组</el-button>
                                                        </td>                                                
                                                    </tr>
                                                    <tr>
                                                        <th>已选考生组</th>
                                                        <td class="groupTd"> 
                                                            <el-scrollbar style="height:100%">
                                                                <el-tag v-for="tag in selectedGroupTags" :key="tag.groupId" closable type="success"
                                                                    :disable-transitions="false" @close="handleCloseTag(tag)">
                                                                    {{tag.groupName}}
                                                                </el-tag>
                                                            </el-scrollbar>
                                                        </td>      
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div> 
                                    </div>
                                    <div class="createExamContainer">
                                        <div class="titleDiv">
                                            <span class="createHeaderTitle"><i class="el-icon-s-home"></i> 基本信息 </span><span class="singAnswerTip">填写考试基本信息</span>
                                        </div>
                                        <div >
                                            <table  style="width: 940px"  class="createExamTable">
                                                <tbody>
                                                    <tr>
                                                        <td> 
                                                            <el-form-item label="考试名称"  prop="examName">  
                                                                <el-input v-model.trim="createExamForm.examName" placeholder="请输入考试名称"      clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td > 
                                                            <el-form-item label="设置试卷"  prop="examPaperName">
                                                                <el-input  placeholder="请选择试卷" @focus="openSelectPaperDialog()" v-model="createExamForm.examPaperName"  >
                                                                    <el-button slot="append"   @click="openSelectPaperDialog()"  icon="el-icon-search" 
                                                                    style="height:40px;background-color:#409EFF;color:white;border-top-left-radius:0;border-bottom-left-radius:0"></el-button>
                                                                </el-input>
                                                                <el-input   v-model="createExamForm.paperId"  v-if="false"></el-input>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td >
                                                            <el-form-item label="考试须知"  prop="examMsg">
                                                                <el-input v-model.trim="createExamForm.examMsg" type="textarea" style="width:800px;" :autosize="{ minRows: 3, maxRows: 3}"  ></el-input>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="createExamContainer">
                                        <div class="titleDiv">
                                            <span class="createHeaderTitle"><i class="el-icon-date"></i> 时间设置</span><span class="singAnswerTip">填写考试时间安排</span>
                                        </div>
                                        <div >
                                            <table  style="width: 940px"  class="createExamTable">
                                                <tbody>
                                                    <tr>
                                                        <!-- <th >报名开始时间</th> -->
                                                        <td > 
                                                            <el-form-item label="报名开始时间"  prop="signStartTime">
                                                                <el-date-picker v-model="createExamForm.signStartTime" type="datetime" placeholder="选择报名开始时间"></el-date-picker>                   
                                                            </el-form-item>
                                                        </td>
                                                        <!-- <th >报名结束时间</th> -->
                                                        <td > 
                                                            <el-form-item label="报名结束时间"  prop="signEndTime">
                                                                <el-date-picker v-model="createExamForm.signEndTime" type="datetime" placeholder="选择报名结束时间"></el-date-picker>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <!-- <th>考试开始时间</th> -->
                                                        <td > 
                                                            <el-form-item label="考试开始时间"  prop="examStartTime">
                                                                <el-date-picker v-model="createExamForm.examStartTime" type="datetime" placeholder="选择考试开始时间"></el-date-picker>
                                                            </el-form-item>
                                                        </td>
                                                        <!-- <th>考试结束时间</th> -->
                                                        <td > 
                                                            <el-form-item label="考试结束时间"  prop="examEndTime">
                                                                <el-date-picker v-model="createExamForm.examEndTime" type="datetime" placeholder="选择考试结束时间"></el-date-picker>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <!-- <th>成绩公布时间</th> -->
                                                        <td > 
                                                            <el-form-item label="成绩公布时间"  prop="resultReleaseTime">
                                                                <el-date-picker v-model="createExamForm.resultReleaseTime" type="datetime" placeholder="选择考试开始时间"></el-date-picker>                               
                                                            </el-form-item>
                                                        </td>
                                                        <td > 
                                                            <el-form-item label="考试时长/分钟"  prop="examDuration">
                                                                <el-input-number v-model="createExamForm.examDuration" controls-position="right" style="width:306px" :min="1" :max="10000"></el-input-number>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>      
                                </el-form>
                                <el-button  type="success" style="width:200px;" @click="submitExamInfo('createExamForm')" :loading="submitLoading">{{submitLoading ? '提交中 ...' : '提 交'}}</el-button>                        
                            </el-scrollbar>
                        </div>
                    </el-tab-pane>      
                </el-tabs>
            </div>
        </el-card>

        
        <!-- 设置试卷对话框-->
        <el-dialog width="850px"  :visible.sync="setPaperDialogVisible">
            <div slot="title" class="dialog-header" >
                <span >选择试卷</span>
            </div>
            <div>                  
                <div class="dialog_search_div" >
                    <el-input v-model="paperQueryParams.paperName" placeholder="试卷关键词" ></el-input>
                    <el-button type="primary" @click="queryExamPaperList()" >查询</el-button>
                </div> 
                <div>              
                    <el-table :data="paperData"  stripe highlight-current-row
                                :header-cell-style="{background:'#eef1f6',color:'#606266'}">  
                        <el-table-column label="序号" align="center" type="index" width="50" ></el-table-column>      
                        <el-table-column prop="paperName" label="试卷名称" width="300"  align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="id" label="试卷ID" v-if="false"></el-table-column>
                        <el-table-column prop="totalCount" label="试卷总分" width="150" align="center"></el-table-column>
                        <el-table-column prop="createTimeStr" label="创建时间" width="250" align="center"> </el-table-column>
                        <el-table-column prop="createTime" v-if="false"> </el-table-column>
                        <el-table-column prop="createBy" label="创建者" width="150" align="center"> </el-table-column>
                        <el-table-column prop="updateTimeStr" label="最后修改时间" width="250" align="center"> </el-table-column>
                        <el-table-column prop="updateBy" label="最后修改者" width="150" align="center"> </el-table-column>
                        <el-table-column fixed="right" label="操作" width="100"  align="center">
                            <template slot-scope="scope">
                                <el-button @click="selectThisPaper(scope.row)" type="success" size="small">使用</el-button>
                            </template>
                    </el-table-column>
                    </el-table>         
                    <el-pagination @size-change="paperSizeChange" @current-change="paperCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                        :current-page="paperQueryParams.pageNum" :page-sizes="[5, 10]" :page-size="paperQueryParams.pageSize" :total="paperTotalCount" class="page">
                    </el-pagination>
                </div>    
            </div>
        </el-dialog>
        <!-- 添加考生组对话框-->
        <el-dialog width="800px"  :visible.sync="addExamineeGroupDialogVisible">
            <div slot="title" class="dialog-header" >
                <span >添加考生组</span>
            </div>
            <div>                  
                <div class="dialog_search_div" >
                    <el-input v-model="groupQueryParams.groupName" clearable placeholder="试卷关键词" ></el-input>
                    <el-button type="primary" @click="queryGroupInfos()" >查询</el-button>
                    <el-button @click="addSelectedGroup()" type="warning" >批量添加</el-button>
                </div> 
                <div>              
                    <el-table :data="examineeGroups"  stripe highlight-current-row @selection-change="examGroupSelectionChange"
                                :header-cell-style="{background:'#eef1f6',color:'#606266'}">  
                        <el-table-column type="selection" width="55" align="center"></el-table-column>       
                        <el-table-column prop="groupName" label="考生组名称" width="300"  align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="groupId" label="考生组ID" v-if="false"></el-table-column>
                        <el-table-column prop="users" label="人数" width="200" align="center">
                            <template slot-scope="scope">
                                {{scope.row.users.length}}
                            </template>
                        </el-table-column>
                        <el-table-column  label="组内人员" width="200"  align="center">
                            <template slot-scope="scope">
                                <el-button @click="previewGroupPeople(scope.row)" type="success" size="mini">预览</el-button>
                            </template>
                    </el-table-column>
                    </el-table>         
                    <el-pagination @size-change="examGroupSizeChange" @current-change="examGroupCurrentChange" layout="total, sizes, prev, pager, next, jumper"
                        :current-page="groupQueryParams.pageNum" :page-sizes="[5, 10]" :page-size="groupQueryParams.pageSize" :total="examineeGroupTotalCount" class="page">  
                    </el-pagination>
                </div>    
            </div>
        </el-dialog>
        <!-- 预览考生组对话框-->
        <el-dialog width="800px"  :visible.sync="previewGroupDialogVisible" append-to-body>
            <div slot="title" class="dialog-header" >
                <span >考生组预览</span>
            </div>
            <div >                  
                <table class="groupTable" width="100%" :data="previewGroupTableData">
                    <tbody>
                        <tr>
                            <th style="width:100px">
                                <b>考生组名称</b>
                            </th>
                            <td class="grTd">{{previewGroupTableData.groupName}}</td>
                        </tr>
                        <tr>
                            <th >
                                <b>组内人数</b>
                            </th>
                            <td class="grTd">{{previewGroupTableData.users.length}}</td>
                        </tr>
                        <tr>
                            <th >
                                <b>组内人员</b>
                            </th>
                            <td>
                                <el-table :data="previewGroupTableData.users" max-height="500px" :header-cell-style="{height:'10px',background:'#eef1f6',color:'#606266'}">
                                    <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
                                    <el-table-column  label="用户名" prop="userName" align="center"></el-table-column>
                                    <el-table-column  label="真实姓名" prop="relayName" align="center"></el-table-column>              
                                </el-table>
                               
                            </td>
                        </tr>
                    </tbody>
                </table>    
            </div>
        </el-dialog>
    </div>  
</template>

<script>
import {queryExamList,addExam, queryExamAndUsers, modifyExam,deleteExames } from '../../api/exam'
import {queryGroupsAndUser, } from '../../api/examineeGroup'
import {queryExamPaperList, } from '../../api/examPaper'
export default {
    data() {
        return {
            activeName:'first',                //el-tab-pane首选页面
            submitLoading: false,               //提交加载
            signDateRange:null,                 //考试管理-报名时间查询参数
            examDateRange:null,                 //考试管理-考试时间查询参数
            examList: [],                       //考试管理-表格数据
            examQueryParams: {                  //考试管理-查询参数
                examId: null,
                examName: null,
                examDuration:null,
                signStartTime:null,
                signEndTime:null,
                signStuNumber:null,
                examStartTime:null,
                examEndTime:null,
                resultReleaseTime:null,
                state: '',
                pageNum: 1,
                pageSize:10,
            }, 
            examTotalCount:0,
            createExamForm:{
                
            },                  //创建考试-考试表单
            selectedGroupTags:[],               //创建考试-已选考生组标签
            addExamineeGroupDialogVisible:false,//添加考生组对话框显示标志
            groupQueryParams: {                 //添加考生组对话框-查询考生组参数
                groupId: null,
                groupName: null,
                state: '1',
                pageNum: 1,
                pageSize:5,
            }, 
            examineeGroups:[],                  //添加考生组对话框-表格数据
            examineeGroupTotalCount:0,          //添加考生组对话框-表格数据总条数
            multipleTable:[],                   //增加考生组对话框-选择的考生组数组
            previewGroupDialogVisible: false,   //预览考生组信息对话框显示标志
            previewGroupTableData:{             //预览考生组信息对话框-表格数据
                users:[],
            },                
            paperQueryParams: {                 //选择试卷对话框-查询参数
                paperId: null,
                paperName: null,
                state: '1',
                pageNum: 1,
                pageSize:5,
            }, 
            paperData:[],                       //选择试卷对话框-试卷数据
            paperTotalCount:0,                  //选择试卷对话框-总数据条数
            modfiyExamForm:{                    //修改考试表单
                examId:'',
                examName:'',
                examMsg:'',
                examDuration: 0 ,
                signStartTime:'',
                signEndTime:'',
                signStuNumber:0,
                examStartTime:'',
                examEndTime:'',
                resultReleaseTime:'',
                state : '0',
                paperId:'',
                examPaperName:'',
                userIds:[]
            },              
            existExaminees:[],                  //修改考试-原有考生   
            setPaperDialogVisible:false,        //设置试卷对话框显示标志
            modifyFlag:false,                   //编辑界面显示标志
            multipleSelection:[],
            rules: {
                examName: [
                    { required: true, message: '请输入考试名称', trigger: 'blur' },
                ],
                examPaperName: [
                    { required: true, message: '请选择考试试卷', trigger: 'change,blur' },
                ],
                examMsg: [
                    { required: true, message: '请输入考试须知', trigger: 'blur' },
                ],
                signStartTime: [
                    { required: true, message: '请选择报名开始时间', trigger: 'change' },
                ],
                signEndTime: [
                    { required: true, message: '请选择报名结束时间', trigger: 'change' },
                ],
                examStartTime: [
                    { required: true, message: '请选择考试开始时间', trigger: 'change' },
                ], 
                examEndTime: [
                    { required: true, message: '请选择考试结束时间', trigger: 'change' },
                ],
                resultReleaseTime: [
                    { required: true, message: '请选择成绩公布时间', trigger: 'change' },
                ],
                examDuration:[
                    { required: true, message: '请输入考试时长', trigger: 'change' },
                ]
            },
           
        };
    },
    watch:{
        signDateRange:function(val){
            if(val != undefined && val != null && val != ''){
                this.examQueryParams.signStartTime = this.dateFormatter(val[0]);
                this.examQueryParams.signEndTime = this.dateFormatter(val[1]);
            }
        },
        examDateRange:function(val){
            if(val != undefined && val != null && val != ''){
                this.examQueryParams.examStartTime = this.dateFormatter(val[0]);
                this.examQueryParams.examEndTime = this.dateFormatter(val[1]);
            }
        },
    },
    created(){
        this.queryExamList();
    },
    methods: {
        //分页查询考试信息
        queryExamList(){
            queryExamList(this.examQueryParams).then(res => {
                if(res.data.code === 200) {
                    this.examList = res.data.rows;
                    this.examTotalCount =  res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        //改变当前记录条数
        examSizeChange(val) {
            this.examQueryParams.pageSize = val;
            this.examQueryParams.pageNum = 1;
            this.queryExamList();
        },
        //改变当前页码
        examCurrentChange(val) {
            this.examQueryParams.pageNum = val;
            this.queryExamList();
        },
        //打开添加考生组对话框
        addExamineeGroup(){
            this.addExamineeGroupDialogVisible = true;
            //查询所有的考生组
            this.queryGroupInfos();
        }, 
        //查询所有的考生组
        queryGroupInfos(){
            queryGroupsAndUser(this.groupQueryParams).then(res => {
                if(res.data.code === 200) {
                    this.examineeGroups = res.data.rows;
                    this.examineeGroupTotalCount = res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });    
                }
            })
        },
        //批量选择
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //批量删除
        deleteSelectedExames(){
            if(this.multipleSelection.length <= 0){
                this.sendMsg("您未选择任何考试，无法删除！", "warning");
                return
            }
            let examIds= [];
            this.multipleSelection.forEach(item => {
                examIds.push(item.examId);
            })
            this.$confirm("此操作将永久删除所选考试, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteExames(examIds).then(res => {
                    //console.log(res);
                    if (res.data.code === 200) {
                        this.sendMsg("删除成功", "success");
                        this.queryExamList();
                    }else {
                        this.sendMsg(res.data.msg, "error");
                    }
                })
            });
        },
        //改变当前记录条数
        examGroupSizeChange(val){
            this.groupQueryParams.pageSize = val;
            this.groupQueryParams.pageNum = 1;
            this.queryGroupInfos();
        },
        //改变当前页码
        examGroupCurrentChange(val){
            this.groupQueryParams.pageNum = val;
            this.queryGroupInfos();
        },
        //添加考生组，批量选择
        examGroupSelectionChange(val) {
            this.multipleTable = val;
        }, 
        //批量添加考试组
        addSelectedGroup(){
            //判断是否选择题目
            if(this.multipleTable.length === 0){
                this.$message({
                    message: '您未勾选任何考生组，请先勾选！',
                    type: 'warning'
                });
                return
            }
            if(this.selectedGroupTags.length === 0){
                //如果未添加任何题目，则直接赋值
                    this.selectedGroupTags = this.multipleTable;
            }else {
                let result = []
                for (let i = 0; i < this.multipleTable.length; i++) {
                    let obj = this.multipleTable[i]
                    let num = obj.groupId;
                    let isExist = false
                    for (let j = 0; j < this.selectedGroupTags.length; j++) {
                        let aj = this.selectedGroupTags[j]
                        let n = aj.groupId
                        if (n === num) {
                            isExist = true
                            break
                        }
                    }
                    if (!isExist) {
                        result.push(obj)
                    }
                }
                if(result.length != 0){
                    result.forEach((multiItem,multiIndex) => {
                        this.selectedGroupTags.push(multiItem)
                    })
                }
            }
            this.addExamineeGroupDialogVisible = false;
        },
        //移除已选择考生组标签
        handleCloseTag(tag) {
            this.selectedGroupTags.splice(this.selectedGroupTags.indexOf(tag), 1);
        },
        //预览考生组内详情 
        previewGroupPeople(row){
            this.previewGroupDialogVisible = true;
            this.previewGroupTableData = row;
        },
        //打开选择试卷 
        openSelectPaperDialog(){
            this.setPaperDialogVisible = true;
            this.queryExamPaperList();
        },
        //查询考试试卷
        queryExamPaperList(){
            queryExamPaperList(this.paperQueryParams).then(res => {
                if(res.data.code === 200) {
                    this.paperData = res.data.rows;
                    this.paperTotalCount =  res.data.total;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        paperSizeChange(val){
            this.paperQueryParams.pageSize = val;
            this.paperQueryParams.pageNum = 1;
            this.queryExamPaperList();
        },
        paperCurrentChange(val){
            this.paperQueryParams.pageNum = val;
            this.queryExamPaperList();
        },
        //使用试卷
        selectThisPaper(row){
            if(this.activeName === 'second'){
                this.createExamForm.examPaperName = row.paperName;
                this.createExamForm.paperId = row.paperId;
            }else{
                this.modfiyExamForm.examPaperName = row.paperName;
                this.modfiyExamForm.paperId = row.paperId;
            }
            this.setPaperDialogVisible = false;
        }, 
        //提交创建考试
        submitExamInfo(formName) {   
            this.submitLoading = false;          
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.activeName === 'second'){
                        //判断时间前后逻辑
                        const result = this.judgeAllTimes('createExamForm');
                        if(!result.value){
                            this.$message({
                                message: result.msg,
                                type: 'warning'
                            }); 
                            return
                        }
                        //考试时长(单位：分钟)
                        // let examDuration =  Math.ceil((this.createExamForm.examEndTime - this.createExamForm.examStartTime)/(1000 * 60));
                        // this.createExamForm.examDuration = examDuration;
                        this.createExamForm.signStartTime = this.dateFormatter(this.createExamForm.signStartTime);
                        this.createExamForm.signEndTime = this.dateFormatter(this.createExamForm.signEndTime);
                        this.createExamForm.examStartTime = this.dateFormatter(this.createExamForm.examStartTime);
                        this.createExamForm.examEndTime = this.dateFormatter(this.createExamForm.examEndTime);
                        this.createExamForm.resultReleaseTime = this.dateFormatter(this.createExamForm.resultReleaseTime);
                        this.createExamForm.createBy = JSON.parse(this.$store.state.loginInfo).userName;
                        this.createExamForm.createName = JSON.parse(this.$store.state.loginInfo).relayName;
                        delete this.createExamForm.examPaperName;
                        let userIds = this.makeSelectedExaminee();
                        this.createExamForm.userIds = userIds;
                        this.createExamForm.signStuNumber = userIds.length;
                        //创建考试
                        addExam(this.createExamForm).then(res => {
                            this.submitLoading = false; 
                            if(res.data.code === 200) {
                                this.selectedGroupTags = [];
                                this.$refs[formName].resetFields();
                                this.$message({
                                    message: '成功创建考试！',
                                    type: 'success',
                                }); 
                            }else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });  
                            }
                        })
                        
                    }else{
                        //判断时间前后逻辑
                        const result = this.judgeAllTimes('modfiyExamForm');
                        if(!result.value){
                            this.$message({
                                message: result.msg,
                                type: 'warning'
                            }); 
                            return
                        }
                        //考试时长(单位：分钟)
                        // const seconds = new Date(this.dateFormatter(this.modfiyExamForm.examEndTime)) - new Date(this.dateFormatter(this.modfiyExamForm.examStartTime));
                        // let examDuration =  Math.ceil(seconds/(1000 * 60));
                        // this.modfiyExamForm.examDuration = examDuration;
                        this.modfiyExamForm.signStartTime = this.dateFormatter(this.modfiyExamForm.signStartTime);
                        this.modfiyExamForm.signEndTime = this.dateFormatter(this.modfiyExamForm.signEndTime);
                        this.modfiyExamForm.examStartTime = this.dateFormatter(this.modfiyExamForm.examStartTime);
                        this.modfiyExamForm.examEndTime = this.dateFormatter(this.modfiyExamForm.examEndTime);
                        this.modfiyExamForm.resultReleaseTime = this.dateFormatter(this.modfiyExamForm.resultReleaseTime);
                        delete this.modfiyExamForm.examPaperName;
                        let userIds = this.makeModifySelectedExaminee();
                        this.modfiyExamForm.userIds = userIds;
                        this.modfiyExamForm.signStuNumber = userIds.length;
                        modifyExam(this.modfiyExamForm).then(res => {
                            this.submitLoading = false;
                            if(res.data.code === 200) {
                                this.selectedGroupTags = [];
                                this.existExaminees = [];
                                this.$refs[formName].resetFields();
                                this.$message({
                                    message: '成功修改考试！',
                                    type: 'success',
                                }); 
                                this.modifyFlag = false; 
                                this.queryExamList();       
                            }else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });  

                            }
                        })
                    }
                }
            });
        },
        //编辑考试信息
        modifyExamInfo(row) { 
            this.modifyFlag = true;
            this.$refs['modfiyExamForm'].resetFields();
            this.modfiyExamForm.state = row.state;
            this.modfiyExamForm.examId = row.examId;
            this.modfiyExamForm.examName = row.examName;
            this.modfiyExamForm.examMsg = row.examMsg;
            this.modfiyExamForm.signStartTime = row.signStartTime;
            this.modfiyExamForm.signEndTime = row.signEndTime;
            this.modfiyExamForm.examStartTime = row.examStartTime;
            this.modfiyExamForm.examEndTime = row.examEndTime;
            this.modfiyExamForm.examDuration = row.examDuration;
            this.modfiyExamForm.resultReleaseTime = row.resultReleaseTime;
            //根据examId向后台请求查询考试信息，将信息显示于对话框中
            queryExamAndUsers(row.examId).then(res => {
                if(res.data.code === 200) {
                    this.modfiyExamForm.paperId = res.data.data.paper.paperId;
                    this.modfiyExamForm.examPaperName = res.data.data.paper.paperName;
                    this.existExaminees = res.data.data.users ? res.data.data.users : [];
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });   
                }
            })
        },
        judgeAllTimes(formName){
            let result = {
                msg:'',
                value:true
            };
            let examform = {};
            if(formName === 'createExamForm'){
                examform = this.createExamForm;
            }else if(formName === 'modfiyExamForm'){
                examform = this.modfiyExamForm;
            }
            if(this.dateFormatter(examform.signEndTime) <= this.dateFormatter(examform.signStartTime)){
                result.value = false;
                result.msg = '报名结束时间不能在开始时间之前！';
                return result
            }
            if(this.dateFormatter(examform.examStartTime) <= this.dateFormatter(examform.signStartTime)){
                result.value = false;
                result.msg = '考试开始时间不能在报名开始时间之前！';
                return result
            }
            if(this.dateFormatter(examform.examEndTime) <= this.dateFormatter(examform.examStartTime)){
                result.value = false;
                result.msg = '考试结束时间不能在考试开始时间之前！';
                return result
            }
            if(this.dateFormatter(examform.resultReleaseTime) <= this.dateFormatter(examform.examEndTime)){
                result.value = false;
                result.msg = '成绩公告时间时间不能在考试结束时间之前！';
                return result
            }
            return result;
        },
        //整合考生组里的考生
        makeSelectedExaminee(){
            const userIds = [];
            if(this.selectedGroupTags.length <=0){
                
                return userIds;
            }else {
                let tempArr = [];
                this.selectedGroupTags.forEach(item =>{
                    item.users.forEach(item1 =>{
                        tempArr.push(item1.userId);
                    })
                });
               
                for (let i = 0 ;i < tempArr.length; i++) {
                    if (userIds.indexOf(tempArr[i]) === -1) {
                        userIds.push(tempArr[i]);
                    }
                }
                return userIds;

            }
        },
        makeModifySelectedExaminee(){
            const userIds = [];
            if(this.selectedGroupTags.length <=0){
                this.existExaminees.forEach(item =>{
                    userIds.push(item.userId);
                })
                return userIds;
            }else {
                let tempArr = [];
                this.selectedGroupTags.forEach(item =>{
                    item.users.forEach(item1 =>{
                        tempArr.push(item1.userId);
                    })
                })
                 this.existExaminees.forEach(item =>{
                    tempArr.push(item.userId);
                })
                for (let i = 0 ;i < tempArr.length; i++) {
                    if (userIds.indexOf(tempArr[i]) === -1) {
                        userIds.push(tempArr[i]);
                    }
                }
                return userIds;

            }
        },
        //查询此次考试的考试记录
        queryExamRecord(row){
            let examId = row.examId;
            this.$router.push({
                path:'/examRecord',
                query:{
                    examId: examId
                }
            })  
        },
        //前往考生组管理页面
        manageGroup(){
             this.$router.push({
                path: '/examineeManage',   
            });
        },
        //回到考试管理主页面
        backToManagerExam(){
            this.modifyFlag = false;
            this.queryExamList();
        },
        //格式化时间格式
        dateFormatter (datetime) {
            if(datetime!= '' && datetime!= null && datetime!= undefined){
                let date = new Date(datetime)
                var year = date.getFullYear()
                var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
                var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
                var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
                var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
                var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
                // 拼接 时间格式处理
                return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
            }else {
                return ''
            }
        },
         //报送信息模板
		sendMsg(msg, type) {
			this.$message({
				message: msg,
				type: type
			});
		}
    }
};
</script>
<style lang="less" scoped>
    .fatherCard {
        width: 1672px;
        position: fixed;
        height: 90vh;
        .list_container {
            display: flex;
            flex-direction: column;
            align-items: center;
            .search-container {
                width: 100%;
                margin-bottom: 10px;
                display: flex;
                //align-items: flex-end;
                justify-content: space-between;
                .el-date-editor {
                    margin-right: 10px;
                }
                .el-input,.el-select {
                    width: 200px;
                    margin-right: 10px;
                }
            }   
        }
    }
    .currentLocation {
        font-weight:bold
    }
    .demo-table-expand {
        display: flex;
        flex-wrap: wrap;
        font-size: 0;
        padding-left: 20px;
    }
    .demo-table-expand /deep/ .el-form-item__label {
        width: 100px;
        color: #99a9bf;
    }
    .demo-table-expand  .halfItem{
        margin-right: 0;
        margin-bottom: 0;
        width: 30%;
    }

    .createExamContainer {
        border: 1.5px #E4E7ED solid;
        margin-bottom: 10px;
    }
    .titleDiv {
        display: flex;
        justify-content: flex-start;
        background: #f5f5f5;
        align-items: center;
        padding: 10px 10px;
    }
    .createHeaderTitle {
        font-weight: bold;
    }
    .singAnswerTip {
        margin-left: 10px;
        font-size: 12px;
        color: #909399;
    }
    .createExamTable {
        border-collapse: collapse;
        border: none;
        margin: 10px 0px 10px 0px;
    }
    .createExamTable tr{
        display: flex; 
        align-items: center;
    }
    .createExamTable .el-input {
        width: 335px;
    }
    .createExamTable th{
        width: 120px;
        font-weight: bold;
        text-align: right;
        font-size: 14px;
        padding: 8px 10px 5px 10px;
        color: #666; 
    }

    .groupTd {
        width: 800px;
        height: 70px;
        border: 1px #E4E7ED solid;
        border-radius: 5px;
        margin: 15px 0px 0px 4px;
    }
    .existGroupTd {
        width: 480px;
        height: 70px;
        border: 1px #E4E7ED solid;
        border-radius: 5px;
        /* margin: 15px 0px 0px 4px; */
    }
    .groupTable {
        border-collapse: collapse;
        border: solid 1px #eee;
    }
    .groupTable tbody {
        color: #000;
    }
    .groupTable th {
        font-weight: normal;
        text-align: right;
        font-size: 12px;
        border: solid 1px #eee;
        background: #f5f5f5;
        line-height: 25px;
        padding: 8px 8px !important;
    }
    .groupTable .grTd{
        padding-left: 10px;
    }
    .dialog_search_div .el-input{
        width: 200px;
        margin-right: 10px;
    }
    .dialog_search_div {
        margin-bottom: 10px;
    }
    .dialog-header {
        width: 800px;
        height: 50px;
        margin-top: -20px;
        margin-left: -20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #F8F8F8;  
        padding-left: 15px;    
    }
    .examListTable /deep/ .el-table__body-wrapper /deep/  .el-table__row {
        height: 55px;
    }
    .el-form-item {
        /* margin-bottom: auto; */
        display: flex;
        align-items: center;
        margin: 0px 0px 10px 43px;

    }
    .el-form-item /deep/ .el-form-item__label {
        font-weight: bold;
        font-size: 14px;
        color: #666;
    }
    .createExamContainer .el-date-editor {
        width: 310px;
    }


    .setPaperButton {
        width: 200px;
        border-top-style: none;
        border-top-right-radius: 0;
    }
   
    
    
   
    .quetionTable td {
        border: solid 1px #eee;
        padding: 8px 8px !important;
        font-size: 9pt;
    }
    .createExamTable td {
        padding: 0px 0px 6px 0px;
    }
    /* .createExamTable .el-select {
        width: 280px;
    } */
    
  
   
    
    .answerInputDiv td{
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .answerInputDiv .el-input {
        width: 620px;
        margin-left: 12px;
    }

    .page {
        margin-top: 10px;
    }
   
   
    
    .dateRange {
         width: 500px;
    }
    

    
    
    
</style>
